// impersonateService.js
const DB_NAME = 'impersonateDB';
const STORE_NAME = 'user_backup';
const BACKUP_KEY = 'originalUser';

function openDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, 1);
        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, {keyPath: 'id'});
            }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

async function backupLocalStorage() {
    // console.log('BACKUP LOCALSTORAGE')
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);

    // console.log("➡️ Save backup with key: originalUser");

    const allData = {};
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        // console.log(key, localStorage.getItem(key))
        allData[key] = localStorage.getItem(key);
    }


    return new Promise((resolve, reject) => {
        const request = store.put({id: BACKUP_KEY, data: allData});
        request.onsuccess = () => {
            // console.log("✅ Données sauvegardées dans IndexedDB");
            db.close();
            resolve();
        };
        request.onerror = (e) => {
            // console.error("❌ Erreur lors de la sauvegarde :", e.target.error);
            db.close();
            reject(e.target.error);
        };
    });
}


async function restoreLocalStorage() {
    // console.log('RESTORE LOCALSTORAGE')

    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);

    const request = store.get(BACKUP_KEY);

    return new Promise((resolve, reject) => {
        request.onsuccess = async () => {
            const result = request.result;
            if (result && result.data) {

                const restoredData = result.data;

                localStorage.clear();

                for (const key in restoredData) {
                    if (restoredData.hasOwnProperty(key)) {
                        // console.log(key, restoredData[key])
                        localStorage.setItem(key, restoredData[key]);
                    }
                }

                // Clear current localStorage first
                // Restore saved keys
                // Object.entries(result.data).forEach(([key, value]) => {
                //     console.log(key,value)
                //     localStorage.setItem(key, value);
                // });
                // Delete backup after restore
                store.delete(BACKUP_KEY);
                db.close();
                const deleteRequest = indexedDB.deleteDatabase(DB_NAME);
                deleteRequest.onsuccess = () => {
                    // console.log("🧹 IndexedDB supprimée après restore");
                    resolve(true);
                };
                deleteRequest.onerror = (e) => {
                    // console.error("❌ Erreur suppression DB :", e.target.error);
                    resolve(false);
                };

                resolve(true);
            } else {
                db.close();
                resolve(false); // no backup to restore
            }
        };
        request.onerror = () => {
            db.close();
            reject(request.error);
        };
    });
}

async function hasBackup() {
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);

    const request = store.get(BACKUP_KEY);

    return new Promise((resolve) => {
        request.onsuccess = () => {
            // console.log(request)
            const result = request.result;
            // console.log('exist')
            // console.log(result)
            db.close();
            resolve(!!result);
        };
        request.onerror = () => {
            // console.log('error')
            db.close();
            resolve(false);
        };
    });
}

export default {
    backupLocalStorage,
    restoreLocalStorage,
    hasBackup
};
